const styles = theme => ({
  container: {
    padding: '16px'
  },
  tableSection: {
    marginTop: '24px',
    backgroundColor: '#fff',
    borderRadius: '4px',
    padding: '16px',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
  },
  tableHeader: {
    marginBottom: '16px',
    borderBottom: '1px solid #e0e0e0',
    paddingBottom: '12px'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '16px',
    '& thead': {
      backgroundColor: '#f5f5f5'
    },
    '& th': {
      padding: '12px',
      textAlign: 'left',
      fontWeight: '600',
      fontSize: '12px',
      color: '#333',
      borderBottom: '1px solid #e0e0e0'
    },
    '& td': {
      padding: '12px',
      borderBottom: '1px solid #f0f0f0',
      fontSize: '13px',
      color: '#555'
    }
  },
  tableRow: {
    '&:hover': {
      backgroundColor: '#fafafa'
    }
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '24px',
    padding: '16px',
    gap: '8px'
  },
  paginationButton: {
    padding: '8px 12px',
    backgroundColor: '#2196f3',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '12px',
    '&:disabled': {
      backgroundColor: '#ccc',
      cursor: 'not-allowed'
    }
  }
})

export default styles
